import React, { Component } from 'react';
import withRouter from './components/withRouter';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';

import requester from "../library/Requester"; 
import * as util from '../library/utilitys';
import * as Actions from './actions/ActionCenter';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import styles from '../styles/frontend/News.css';

const VIEW = `frontend_publicize_data`;
const URL = `public/view/frontent/tops-info`;
const ATTACH_FILE_CONTENT_URL = `public/view/attach_files/files`;

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newTypes: props.params?.newTypes || null,
      id: props.params?.id || null,
      preview: props.params?.preview || null,
      DataTable1: [],
      DatatableImage1: {},
      DatatableImage2: {},
    };
  }

  componentDidMount = async () => {
    await this.loadDataToState();
  }

  loadDataToState = async () => {
    try {
      const { id,preview } = this.state;
      const response = await requester.post(`${URL}/${VIEW}`, { id, preview, pageSize: 1 });
      const data = response.data?.data?.data?.[0] || response.data?.data?.[0] || null;

      if (data) {
        this.setState({ DataTable1: data }, async () => {
          const imageMap = await Actions.loadImageBlobUrls({
            rows: [data],
            fileField: "photo",
            idField: "id",
            baseUrl: ATTACH_FILE_CONTENT_URL
          });
          this.setState({ DatatableImage1: imageMap });
        });

        if (data.files) {
          const fileMap = await Actions.loadImageBlobUrls({
            rows: [data],
            fileField: "files",
            idField: "id",
            baseUrl: ATTACH_FILE_CONTENT_URL
          });
          this.setState({ DatatableImage2: fileMap });
        }
      }
    } catch (error) {
      console.error("Failed to load data by ID:", error);
    }
  };

  isDisplayableFile = (filename) => {
    if (!filename) return false;
    const ext = filename.split('.').pop().toLowerCase();
    const imageExts = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
    return imageExts.includes(ext);
  };

  isPdfFile = (filename) => {
    if (!filename) return false;
    const ext = filename.split('.').pop().toLowerCase();
    return ext === 'pdf';
  };

  getFileName = (filepath) => {
    if (!filepath) return '';
    return filepath.split('/').pop().split('\\').pop();
  };

  loadImages = async (sourceStateKey, targetImageStateKey = "") => {
    const rows = this.state[sourceStateKey] || [];    
    const getImage = await Actions.loadImageBlobUrls({
      rows,
      fileField: "photo",
      idField: "id",
      baseUrl: ATTACH_FILE_CONTENT_URL
    });
    this.setState({ [targetImageStateKey]: getImage });
  };

  handleMapClick = () => {
    const { DataTable1 } = this.state;
    if (DataTable1?.location) {
      const encodedLocation = encodeURIComponent(DataTable1.location);
      window.open(`https://www.google.com/maps/search/${encodedLocation}`, '_blank');
    } else {
      window.open('https://www.google.com/maps', '_blank');
    }
  };


  render() {
    
    const { DataTable1, DatatableImage1, DatatableImage2 } = this.state;
    if (!DataTable1) return null;

    const imageUrl = DatatableImage1?.[DataTable1.id] || "/images/default-image.jpg";


    return (
      <div className={styles.pageContainer} style={{ backgroundImage: "url('/images/img__3.png')", backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
        <Header />

        <Container className="mt-4">
          <Row className="mb-4 text-center">
            
              {DataTable1?.source_type === "vacancy" ?<p className="section-subtitle">ประชาสัมพันธ์ตำแหน่งว่าง</p>:''}
              {DataTable1?.source_type === "general"||DataTable1?.source_type === ""?<p className="section-subtitle">ประชาสัมพันธ์ข่าวสารทั่วไป</p>:''}
            {/* <h1 className="section-title">{DataTable1?.name}</h1> */}
          </Row>

          <Row className="justify-content-center py-4">
            <Col xs={12} className="position-relative text-center">
            
              <Image 
                src={imageUrl}
                alt="ศูนย์ EEC"
                className="img-fluid"
                style={{ width: '75%', maxHeight: '500px', objectFit: 'cover', borderRadius: '24px' }}
              />
            </Col>
          </Row>

          <Row className="px-3 py-4 mt-6 justify-content-center">
            <Col lg={8} className="mb-4">
              <Card className="mb-4">
                  <Card.Body>
                  
                    <h2 className="section-heading">{DataTable1?.name}</h2>
                    <p className="news-detail">
                      {DataTable1?.detail}
                    </p>
                    <hr/>

                    {DataTable1?.source_type === "vacancy" ?
                      <>
                        <h3 className="section-subheading">ข้อมูลเพิ่มเติม</h3>
                          <ul>
                            <li>สถานศึกษา: {DataTable1?.academy_name	}</li>
                            <li>จำนวนความต้องการ: {DataTable1?.people_count} ตำแหน่ง</li>
                            <li>หน่วยงาน/บริษัท: {DataTable1?.enterprise_name}</li>
                          </ul>

                          <h3 className="section-subheading">รายละเอียดการติดต่อเพิ่มเติม</h3>
                          <ul>
                            <li>{DataTable1?.contact_detail	}</li>
                          </ul>
                      </>
                    : null}
                    {DataTable1?.source_type === "vacancy" ?
                      <>
                        <h3 className="section-subheading">ข้อมูลเพิ่มเติม</h3>
                        <ul>
                          <li>ตำแหน่งงานที่ต้องการ: {DataTable1?.position_name}</li>
                          <li>จำนวนความต้องการ: {DataTable1?.people_count} ตำแหน่ง</li>
                          <li>หน่วยงาน/บริษัท: {DataTable1?.enterprise_name}</li>
                        </ul>

                        <h3 className="section-subheading">รายละเอียดการติดต่อเพิ่มเติม</h3>
                        <ul>
                          <li>{DataTable1?.contact_detail	}</li>
                        </ul>

                        {/*
                        <h3 className="section-subheading">วัตถุประสงค์หลักของศูนย์</h3>
                        <ul>
                          <li>พัฒนาบุคลากรในสาขาเซมิคอนดักเตอร์ สร้างทักษะที่จำเป็นสำหรับอุตสาหกรรมเซมิคอนดักเตอร์</li>
                          <li>จัดอบรมหลักสูตรเฉพาะทางร่วมกับภาคอุตสาหกรรม เช่น การออกแบบชิป, การผลิตไมโครชิป, การทดสอบ, การประกอบ ฯลฯ</li>
                          <li>เป็นศูนย์กลางฝึกอบรมในระดับสากล รองรับผู้เข้าอบรมทั้งนักศึกษา ครูอาจารย์ และบุคลากรจากภาคเอกชน</li>
                          <li>สนับสนุนอุตสาหกรรมเป้าหมายใน EEC เช่น Smart Electronics, AI, IoT, และ EV</li>
                        </ul>

                        <h3 className="section-subheading">ตัวอย่างการดำเนินงาน</h3>
                        <ul>
                          <li>เปิดหลักสูตร "Digital IC Design and Semiconductor Packaging"</li>
                          <li>จัด Bootcamp ฝึกงานร่วมกับบริษัท</li>
                          <li>มีความร่วมมือกับหน่วยงานทั้งในและต่างประเทศ เช่น TSMC, IMEC, GlobalFoundries ฯลฯ</li>
                          <li>มีเป้าหมายผลิตบุคลากรระดับปริญญาตรี – ปริญญาเอก และ Reskill/Upskill แรงงานอุตสาหกรรม</li>
                        </ul>
                        */}
                      </>
                    : null}

                    {DataTable1?.files ? (
                      <div className="news-attachment mt-3 mb-3">
                        {(() => {
                          const fileUrl = DatatableImage2?.[DataTable1.id];
                          const displayName = DataTable1.files_file_name || 'ไฟล์แนบ';

                          if (!fileUrl) {
                            return <span className="text-muted">กำลังโหลดไฟล์แนบ...</span>;
                          }

                          if (this.isDisplayableFile(DataTable1.files_file_name)) {
                            return (
                              <Image 
                                src={fileUrl} 
                                alt={displayName}
                                className="img-fluid rounded"
                                style={{ maxWidth: '100%' }}
                              />
                            );
                          }

                          if (this.isPdfFile(DataTable1.files_file_name)) {
                            return (
                              <div>
                                <iframe 
                                  src={fileUrl} 
                                  title={displayName}
                                  style={{ width: '100%', height: '600px', border: 'none' }}
                                />
                                <a 
                                  href={fileUrl} 
                                  download={displayName}
                                  className="btn bg-global-12 text-global-6 mt-2"
                                >
                                  ดาวน์โหลดไฟล์ PDF
                                </a>
                              </div>
                            );
                          }

                          return (
                            <a 
                              href={fileUrl} 
                              download={displayName}
                              className="btn bg-global-12 text-global-6"
                            >
                              ดาวน์โหลดไฟล์แนบ: {displayName}
                            </a>
                          );
                        })()}
                      </div>
                    ) : null}

                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} className="mb-4">
              <div className="sidebar-box">
                {/* <div className="sidebar-item">
                  <img src="/images/img_people.svg" alt="People" className="icon" />
                  <span className="label">จำนวนบุคลากร</span>
                  <p className="value">จำนวนทั้งสิ้น 100 คน</p>
                </div>

                <div className="sidebar-item">
                  <img src="/images/img_vuesax_bold_briefcase.svg" alt="Experience" className="icon" />
                  <span className="label">Experience</span>
                  <p className="value">Minimum 1 Year</p>
                </div> */}

                {DataTable1?.user_contact ? 
                <div className="sidebar-item">
                  <img src="/images/img_call.svg" alt="Phone" className="icon" />
                  <span className="label">ติดต่อ</span>
                  <p className="value">โทรศัพท์ {DataTable1?.user_contact	}</p>
                </div>
                :''}

                {DataTable1?.user_email ? 
                <div className="sidebar-item">
                  <img src="/images/img_sms.svg" alt="Email" className="icon" />
                  <span className="label">อีเมล</span>
                  <p className="value">{DataTable1?.user_email	}</p>
                </div>
                :''}

                {DataTable1?.url_link ? 
                  <div className="sidebar-item">
                    <img src="/images/img_vuesax_bold_global.svg" alt="Website" className="icon" />
                    <span className="label">เว็บไซต์</span>
                    <p className="value">
                      <a 
                        href={DataTable1.url_link.startsWith('http') ? DataTable1.url_link : `https://${DataTable1.url_link}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-break"
                      >
                        {DataTable1.url_link}
                      </a>
                    </p>
                  </div>
                :''}

                {DataTable1?.location ? 
                <div className="sidebar-item">
                  <img src="/images/img_vuesax_bold_location.svg" alt="Location" className="icon" />
                  <span className="label">ที่ตั้ง</span>
                  <p className="value">{DataTable1?.location}</p>
                </div>
                :''}

                {/* <div className="map-box mb-3">*** MAP ***</div> */}

                <Button 
                  onClick={this.handleMapClick}
                  className="w-100 bg-global-12 text-global-6 border border-global-12 d-flex align-items-center justify-content-center gap-2"
                >
                  <img src="/images/img_map.svg" alt="Map" className="me-2" />
                  ไปยังแผนที่
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
        <Footer />
      </div>
    );
  }
}

export default withRouter(News);